import { axiosInstance } from '@/shared/api/axios';
import {
  AiReportGetTokenResponseType,
  AiReportGetTokenRequestType,
  AiReportGetCheckStatusRequestType,
  AiReportGetCheckStatusResponseType,
  AiReportGetStatusRequestType,
  AiReportGetStatusResponseType,
} from '@/shared/types/api/api.aiReport';

export const getJwtToken = async ({
  groupId,
  customerId,
  checkExecutionId,
}: AiReportGetTokenRequestType): Promise<AiReportGetTokenResponseType> => {
  const { data } = await axiosInstance.get<AiReportGetTokenResponseType>(
    `/group/${groupId}/customers/${customerId}/checkExecutions/${checkExecutionId}/aiReport/token`,
  );
  return data;
};

export const getCheckReportStatus = async ({
  groupId,
  reportToken,
}: AiReportGetCheckStatusRequestType): Promise<AiReportGetCheckStatusResponseType> => {
  const { data } = await axiosInstance.get<AiReportGetCheckStatusResponseType>(
    `/group/${groupId}/aiReport/check?token=${reportToken}`,
  );
  return data;
};

export const getAiReportStatus = async ({
  groupId,
  checkExecutionId,
}: AiReportGetStatusRequestType): Promise<AiReportGetStatusResponseType> => {
  const { data } = await axiosInstance.get<AiReportGetStatusResponseType>(
    `/group/${groupId}/aiReport/check-executions/${checkExecutionId}/status`,
  );
  return data;
};
